import { Mensaje } from "./Message/message";
import "./modal.css";

const Modal = ({ titulo,children, btnEnviarReferencia=<></>, agrgandodocumento=false, isOpen, closeModal, Width ,Height, closeModal_Article=()=>{} }) => {
  const handleModalContainerClick = (e) => e.stopPropagation();



  const CerrarModal=()=>{
    if(agrgandodocumento){
      Mensaje("DEBE TERMINAR DE AGREGAR EL NUEVO DOCUMENTO O CANCELARLO.","error", "top-center", 3000)
      return;
    }else{
      closeModal();
    }
  }

  return (
    /*<article className={`modal ${isOpen && "is-open"}`}  onClick={closeModal_Article} >
      <div className="modal-container" onClick={handleModalContainerClick} style={{width: Width,height: Height}}>
        <h3>{titulo}</h3>
        <button type="button"  onClick={closeModal} className="btn-close modal-close"   aria-label="Close"></button>
        <hr></hr>
        {children}
      </div>
    </article>*/
    <article className={`modal ${isOpen && "is-open"}`}  onClick={closeModal_Article} >
    <div className="modal-content "  onClick={handleModalContainerClick} style={{width: Width,height: Height, overflow:"auto"}}>
      <div className="modal-header">
        <p className="modal-title h4 " id="exampleModalLabel">{titulo}</p>

        
        <button type="button"  onClick={CerrarModal} className="btn-close modal-close"   aria-label="Close"></button>
        
      </div>
      <div className="modal-body"> 
      {children}
      </div>
      
    </div>
    </article>
  );
};

export default Modal;